import React from 'react'

const SvgIconDown = () => {
    return (
        <svg className="bi bi-chevron-down" tabIndex="-1" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" tabIndex="-1" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
        </svg>
    )
}

const SvgIconLeft = (bold) => {
    return (<>
        {
            bold ? (<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" className="svg-inline--fa fa-chevron-left fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path></svg>) :
                (<svg className="bi bi-chevron-left" tabIndex="-1" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" tabIndex="-1" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" /></svg>)
        }</>
    )
}

const SvgIconRight = (bold) => {
    return (<>
        {
            bold ? (<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" className="svg-inline--fa fa-chevron-right fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg>) :
                (<svg className="bi bi-chevron-right" tabIndex="-1" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" tabIndex="-1" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" /></svg>)
        }
    </>)
}

const SvgCallAnswer = () => {
    return (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M23.462,18.983l-3.706-3.715a1.929,1.929,0,0,0-2.725.051L15.163,17.19l-.368-.205A18.583,18.583,0,0,1,10.3,13.729a18.728,18.728,0,0,1-3.255-4.51c-.069-.125-.135-.246-.2-.361L8.1,7.6l.616-.618a1.938,1.938,0,0,0,.05-2.731L5.06.539A1.927,1.927,0,0,0,2.336.59L1.291,1.643l.029.028A6.058,6.058,0,0,0,.459,3.194,6.321,6.321,0,0,0,.076,4.737C-.414,8.8,1.44,12.52,6.472,17.563c6.955,6.971,12.56,6.444,12.8,6.418a6.251,6.251,0,0,0,1.544-.389,6.017,6.017,0,0,0,1.513-.859l.023.02,1.058-1.039A1.942,1.942,0,0,0,23.462,18.983Z" fill="#767676" /></svg>)
}

const SvgSearch = () => {
    return (
        <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="search" className="svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M508.5 468.9L387.1 347.5c-2.3-2.3-5.3-3.5-8.5-3.5h-13.2c31.5-36.5 50.6-84 50.6-136C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c52 0 99.5-19.1 136-50.6v13.2c0 3.2 1.3 6.2 3.5 8.5l121.4 121.4c4.7 4.7 12.3 4.7 17 0l22.6-22.6c4.7-4.7 4.7-12.3 0-17zM208 368c-88.4 0-160-71.6-160-160S119.6 48 208 48s160 71.6 160 160-71.6 160-160 160z"></path></svg>
    )
}

const SvgSortDown = () => {
    return (
        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="sort-down" className="svg-inline--fa fa-sort-down fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"></path></svg>
    )
}

const SvgSortUp = () => {
    return (
        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="sort-up" className="svg-inline--fa fa-sort-up fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"></path></svg>
    )
}

const SvgSearchCondition = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="26.689" height="26.689" viewBox="0 0 26.689 26.689">
            <g id="Icon" transform="translate(0 13.327) rotate(-45)">
                <g id="Ellipse_382" data-name="Ellipse 382" fill="none" stroke="#606060" strokeWidth="2">
                    <circle cx="9.424" cy="9.424" r="9.424" stroke="none" />
                    <circle cx="9.424" cy="9.424" r="8.424" fill="none" />
                </g>
                <line id="Line_362" data-name="Line 362" y2="8.699" transform="translate(9.424 18.122)" fill="none" stroke="#606060" strokeWidth="3" />
            </g>
        </svg>
    )
}

const SvgPhoneBlue = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><defs></defs><path fill="#0067c5" id="Path_104" data-name="Path 104" d="M165.641-14.345l-2.471-2.477a1.286,1.286,0,0,0-1.817.034l-1.245,1.247-.246-.137a12.389,12.389,0,0,1-2.994-2.171,12.486,12.486,0,0,1-2.17-3.006c-.046-.084-.09-.164-.134-.241l.836-.836.411-.412a1.292,1.292,0,0,0,.033-1.821l-2.471-2.477a1.285,1.285,0,0,0-1.816.034l-.7.7.019.019a4.039,4.039,0,0,0-.574,1.014,4.211,4.211,0,0,0-.255,1.029c-.326,2.711.91,5.189,4.264,8.551,4.637,4.647,8.374,4.3,8.535,4.279a4.167,4.167,0,0,0,1.03-.259,4.011,4.011,0,0,0,1.009-.573l.015.014.706-.692A1.3,1.3,0,0,0,165.641-14.345Z" transform="translate(-150 27)" /></svg>
    )
}

const SvgCheck = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17.348" height="17.348" viewBox="0 0 17.348 17.348">
            <g data-name="Group 3337" transform="translate(-45.765 -216.731)">
                <g data-name="Group 3157" transform="translate(-690.235 -521.269)">
                    <circle data-name="Ellipse 391" cx="7.71" cy="7.71" r="7.71" transform="translate(737.285 739.285)" fill="currentColor" />
                    <g data-name="Path 824-5" transform="translate(736 738)">
                        <path data-name="Path 824-5" d="M449.79,86.26a8.674,8.674,0,1,0,8.674,8.674,8.674,8.674,0,0,0-8.674-8.674Zm3.188,8.267-5.654,5.308-3.945-3.919,1.478-1.471,2.466,2.451,4.626-4.3,2.769-2.57,1.478,1.471Z" transform="translate(-441.116 -86.26)" fill="#fff" />
                    </g>
                </g>
            </g>
        </svg>
    )
}

const SvgArrowDown = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="41.132" height="22.148" viewBox="0 0 41.132 22.148">
            <path id="Path_1448" data-name="Path 1448" d="M196.82-773.517l-14.772-15.641a3.007,3.007,0,0,1,0-4.08,2.619,2.619,0,0,1,3.854,0l16.7,17.681a3.006,3.006,0,0,1,0,4.08L185.9-753.8a2.619,2.619,0,0,1-3.854,0,3.007,3.007,0,0,1,0-4.08Z" transform="translate(-752.951 -181.25) rotate(90)" fill="#acabab" opacity="0.4" />
        </svg>
    )
}

const SvgPhoneCircle = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
            <g id="Group_3780" data-name="Group 3780" transform="translate(-5196 -14801)">
                <circle id="Oval" cx="20" cy="20" r="20" transform="translate(5196 14801)" fill="#0067c5" />
                <path d="M22.851,17.11v3.44a2.3,2.3,0,0,1-2.5,2.294,22.766,22.766,0,0,1-9.916-3.521,22.384,22.384,0,0,1-6.894-6.881A22.667,22.667,0,0,1,.009,2.5,2.3,2.3,0,0,1,2.3,0H5.743a2.3,2.3,0,0,1,2.3,1.972,14.7,14.7,0,0,0,.8,3.222,2.29,2.29,0,0,1-.517,2.42L6.869,9.071a18.366,18.366,0,0,0,6.894,6.881L15.222,14.5a2.3,2.3,0,0,1,2.424-.516,14.776,14.776,0,0,0,3.229.8,2.3,2.3,0,0,1,1.976,2.328Z" transform="translate(5204.574 14809.573)" fill="#fff" />
            </g>
        </svg>
    )
}
const SvgPhoneFinder = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24.5" height="24.5" viewBox="0 0 24.5 24.5">
            <g id="iconfinder_phone-call_3324964_1_" data-name="iconfinder_phone-call_3324964 (1)" transform="translate(-0.5 0)">
                <path id="Shape" d="M4.539,9.117l0,0L0,4.587A5.718,5.718,0,0,1,4.538,9.114Zm4.6-.012,0,0L0,0A10.388,10.388,0,0,1,6.166,2.955,10.349,10.349,0,0,1,9.134,9.1Z" transform="translate(15.366 0.5)" fill="#d8d8d8" stroke="#d8d8d8" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1" />
                <path d="M22.851,17.11v3.44a2.3,2.3,0,0,1-2.5,2.294,22.766,22.766,0,0,1-9.916-3.521,22.384,22.384,0,0,1-6.894-6.881A22.667,22.667,0,0,1,.009,2.5,2.3,2.3,0,0,1,2.3,0H5.743a2.3,2.3,0,0,1,2.3,1.972,14.7,14.7,0,0,0,.8,3.222,2.29,2.29,0,0,1-.517,2.42L6.869,9.071a18.366,18.366,0,0,0,6.894,6.881L15.222,14.5a2.3,2.3,0,0,1,2.424-.516,14.776,14.776,0,0,0,3.229.8,2.3,2.3,0,0,1,1.976,2.328Z" transform="translate(0.5 1.647)" fill="#d8d8d8" />
            </g>
        </svg>
    )
}

const SvgIcon = (type) => {
    var content = '';
    var bold = type.bold ? type.bold : false;
    switch (type.type) {
        case 'right':
            content = <SvgIconRight bold={bold} />
            break;
        case 'left':
            content = <SvgIconLeft bold={bold} />
            break;
        case 'phone':
            content = <SvgCallAnswer />
            break;
        case 'phone-blue':
            content = <SvgPhoneBlue />
            break;
        case 'search':
            content = <SvgSearch />
            break;
        case 'sort-down':
            content = <SvgSortDown />
            break;
        case 'sort-up':
            content = <SvgSortUp />
            break;
        case 'search-condition':
            content = <SvgSearchCondition />
            break;
        case 'check':
            content = <SvgCheck />
            break;
        case 'arrow-down':
            content = <SvgArrowDown />
            break;
        case 'phone-circle':
            content = <SvgPhoneCircle />
            break;
        case 'phone-finder':
            content = <SvgPhoneFinder />
            break;
        default:
            content = <SvgIconDown bold={bold} />
            break;
    }
    return (<>{content}</>)
}

export { SvgIcon };
